import { render, staticRenderFns } from "./SubmitForm16.vue?vue&type=template&id=08a73dfd&scoped=true"
import script from "./SubmitForm16.vue?vue&type=script&lang=ts"
export * from "./SubmitForm16.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a73dfd",
  null
  
)

export default component.exports